import { render, staticRenderFns } from "./JoinRequest.vue?vue&type=template&id=e0088e50&"
import script from "./JoinRequest.vue?vue&type=script&lang=ts&"
export * from "./JoinRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports